const BUSINESS_TYPES = [
  {
    label: "Comerciante Agrícola / Loja Rural",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Abrigo de Animais / Caridade",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Lote de Recria",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Produtor de Carne Bovina",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Frangos de Corte", value: "Broilers", id: "broilers" },
  {
    label: "Grupo de Compra",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Produção de Bezerros",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Fazenda/Desenvolvedor de Bezerros",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Comprador de Gado", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Produtor Contratado",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperativa", value: "Cooperative", id: "cooperative" },
  {
    label: "Escritório Corporativo",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Operação Vaca/Bezerro",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Produção Leiteira",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distribuidor / Agente",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Fábrica de Ração", value: "Feed Mill", id: "feed_mill" },
  { label: "Confinamento", value: "Feedyard", id: "feedyard" },
  {
    label: "Produtor/Recria",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Incubatório", value: "Hatchery", id: "hatchery" },
  {
    label: "Produção de Novilhas",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Integração de Poedeiras",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Poedeiras", value: "Layers", id: "layers" },
  { label: "Mídia", value: "Media", id: "media" },
  {
    label: "Cooperativa/Comprador de Leite",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Produtor Misto/Outro",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Fornecedor de Nutrientes",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Frigorífico/Processador",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Loja de Varejo de Animais de Estimação",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Farmácia", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Criador de Aves",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Integrador Avícola",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  {
    label: "Produtor de Ovinos",
    value: "Sheep Producer",
    id: "sheep_producer",
  },
  {
    label: "Operação de Engorda",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Curral/Feira de Gado",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  {
    label: "Produtor de Suínos",
    value: "Swine Producer",
    id: "swine_producer",
  },
  { label: "Perus", value: "Turkeys", id: "turkeys" },
  {
    label: "Universidade / Educação",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Clínica Veterinária",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Atacadista / Varejista",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Comprador de Lã", value: "Wool Buyer", id: "wool_buyer" },
];
const FIELDS = {
  common: {
    errors: {
      required: "Obrigatório",
    },
  },
  salutation: {
    label: "Saudação",
    placeholder: "Selecione a Saudação",
    errors: {
      required: "A saudação é obrigatória",
      invalid: "Por favor, selecione uma saudação válida",
    },
  },
  firstName: {
    label: "Primeiro Nome",
    placeholder: "João",
    errors: {
      required: "O primeiro nome é obrigatório",
      minLength: "O primeiro nome deve ter pelo menos 2 caracteres",
      maxLength: "O primeiro nome deve ter no máximo 50 caracteres",
    },
  },
  lastName: {
    label: "Sobrenome",
    placeholder: "Silva",
    errors: {
      required: "O sobrenome é obrigatório",
      minLength: "O sobrenome deve ter pelo menos 2 caracteres",
      maxLength: "O sobrenome deve ter no máximo 50 caracteres",
    },
  },
  email: {
    label: "E-mail",
    placeholder: "joao.silva@example.org",
    description:
      "Por favor, insira um endereço de e-mail que seja pessoal para você, não um endereço de e-mail compartilhado.",
    prefixWarningTitle: "Caixa de correio compartilhada detectada",
    prefixWarningDescription:
      "Recomendamos usar um endereço de e-mail pessoal para uma experiência personalizada superior",
    errors: {
      required: "O e-mail é obrigatório",
      invalidEmail: "Por favor, insira um endereço de e-mail válido",
      emailAssociatedWithYourAccount:
        "Seu endereço de e-mail está associado à sua conta e não pode ser alterado.",
    },
  },
  confirmEmail: {
    label: "Confirmar E-mail",
    placeholder: "joao.silva@example.org",
    errors: {
      required: "A confirmação do e-mail é obrigatória",
      invalidEmail: "Por favor, insira um endereço de e-mail válido",
      emailMatchError: "Os endereços de e-mail não correspondem",
    },
  },
  password: {
    label: "Senha",
    placeholder: "Digite sua senha",
    errors: {
      required: "A senha é obrigatória",
    },
  },
  confirmPassword: {
    label: "Confirmar Senha",
    placeholder: "Confirme sua senha",
    errors: {
      required: "A confirmação da senha é obrigatória",
      passwordMatchError: "As senhas não correspondem",
    },
  },
  addressLine1: {
    label: "Endereço Linha 1",
    placeholder: "Rua Principal 123",
    errors: {
      required: "O endereço Linha 1 é obrigatório",
      minLength: "O endereço Linha 1 deve ter pelo menos 5 caracteres",
      maxLength: "O endereço Linha 1 deve ter no máximo 100 caracteres",
    },
  },
  addressLine2: {
    label: "Endereço Linha 2",
    placeholder: "Apto 4B",
    errors: {
      required: "O endereço Linha 2 é obrigatório",
      maxLength: "O endereço Linha 2 deve ter no máximo 100 caracteres",
    },
  },
  city: {
    label: "Cidade",
    placeholder: "São Paulo",
    errors: {
      required: "A cidade é obrigatória",
      minLength: "A cidade deve ter pelo menos 2 caracteres",
      maxLength: "A cidade deve ter no máximo 50 caracteres",
    },
  },
  state: {
    label: "Estado",
    placeholder: "Selecione o Estado",
    errors: {
      required: "O estado é obrigatório",
      invalid: "Por favor, selecione um estado válido",
    },
  },
  jurisdiction: {
    label: "Jurisdição da Licença",
    placeholder: "Selecione a jurisdição da licença",
    errors: {
      required: "A jurisdição da licença é obrigatória",
      invalid: "Por favor, selecione uma jurisdição válida",
    },
  },
  zipCode: {
    label: "CEP",
    placeholder: "01000-000",
    errors: {
      required: "O CEP é obrigatório",
      invalid: "Por favor, insira um CEP válido",
    },
  },
  role: {
    label: "Função",
    placeholder: "Selecione sua função",
    errors: {
      required: "Por favor, selecione sua função",
      invalid: "Por favor, selecione uma função válida",
    },
  },
  businessType: {
    label: "Tipo de Negócio",
    placeholder: "Selecione o Tipo de Negócio",
    errors: {
      required: "O tipo de negócio é obrigatório",
      invalid: "Por favor, selecione um tipo de negócio válido",
    },
  },
  businessName: {
    label: "Nome do Negócio",
    placeholder: "Digite o nome do negócio",
    errors: {
      required: "O nome do negócio é obrigatório",
      minLength: "O nome do negócio deve ter pelo menos 2 caracteres",
      maxLength: "O nome do negócio deve ter no máximo 100 caracteres",
    },
  },
  businessSearch: {
    label: "Pesquisa de Negócios:",
    addNewAccount: "Adicionar Nova Conta de Negócio",
    canNotFindBusiness: "Não consegue encontrar seu negócio?",
    guideline: "Por favor, insira seu CEP e selecione na lista abaixo.",
    guidelineForNameSearch:
      "Por favor, insira o nome completo do negócio e selecione na lista.",
    placeholder: "Onde você trabalha?",
    noResults: "Nenhum resultado encontrado",
    searching: "Pesquisando...",
    selectedBusinessHeading: "Negócio Selecionado:",
    selectedBusinessNotCorrect: "Não está correto?",
    selectedBusinessTryAgain: "Tentar novamente",
    selectedBusinessDismiss: "Descartar negócio",
    resultsFound: {
      singular: "1 negócio encontrado",
      plural: "Múltiplos negócios encontrados",
    },
    errors: {
      network:
        "Estamos com problemas para conectar ao localizador de negócios. Por favor, tente novamente mais tarde.",
    },
  },
  explicitConsent: {
    label:
      "Ao marcar esta caixa, concordo com os Termos de Uso da Elanco e reconheço que a Elanco coletará e processará minhas informações pessoais de acordo com a Política de Privacidade da Elanco",
    errors: {
      required: "O consentimento de e-mail é obrigatório",
    },
  },
  explicitSmsConsent: {
    label:
      "Ao marcar esta caixa, concordo em receber comunicações de marketing da Elanco por SMS/mensagem de texto.",
    errors: {
      required: "O consentimento para SMS é obrigatório",
    },
  },
  telephone: {
    label: "Telefone pessoal",
    placeholder: "Digite seu telefone pessoal",
    dialCodeLabel: "Código do país",
    dialCodePlaceholder: "Buscar país…",
    errors: {
      invalid: "Por favor, insira um número de telefone válido.",
    },
  },
  businessTelephone: {
    label: "Telefone comercial",
    placeholder: "Digite seu telefone comercial",
    dialCodeLabel: "Código do país",
    dialCodePlaceholder: "Buscar país…",
    errors: {
      invalid: "Por favor, insira um número de telefone válido.",
    },
  },
  professionalNumber: {
    label: "Número Profissional",
    placeholder: "1234567",
    errors: {
      required: "Por favor, digite um número profissional",
      maxLength: "Entrada excede o limite de caracteres",
    },
  },
  addressSearch: {
    errors: {
      required: "Este campo é obrigatório",
    },
  },
  businessSearchField: {
    errors: {
      required: "Este campo é obrigatório",
    },
  },
  checkbox: {
    errors: {
      required: "Este campo é obrigatório",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Este campo é obrigatório",
    },
  },
  combobox: {
    errors: {
      required: "Este campo é obrigatório",
    },
  },
  datePicker: {
    errors: {
      required: "Este campo é obrigatório",
    },
  },
  dateRange: {
    errors: {
      required: "Este campo é obrigatório",
    },
  },
  dateTime: {
    errors: {
      required: "Este campo é obrigatório",
    },
  },
  emailField: {
    errors: {
      required: "Este campo é obrigatório",
    },
  },
  fileInput: {
    errors: {
      required: "Por favor, selecione um arquivo",
    },
  },
  number: {
    errors: {
      required: "Por favor, insira um número",
      minValue: "Por favor, insira um valor maior que o mínimo",
      maxValue: "Por favor, insira um valor menor que o máximo",
    },
  },
  passwordField: {
    errors: {
      required: "Este campo é obrigatório",
    },
  },
  rangeSlider: {
    errors: {
      required: "Este campo é obrigatório",
    },
  },
  select: {
    errors: {
      required: "Este campo é obrigatório",
    },
  },
  telephoneField: {
    errors: {
      required: "Por favor, insira apenas números",
      invalidTelephone: "Por favor, insira um número de telefone válido",
      invalidFormat: "Formato de número inválido",
    },
  },
  text: {
    errors: {
      required:
        "Por favor, use apenas letras (A-Z), números (0-9) e nenhum símbolo",
      maxLength: "A entrada excede o limite de caracteres",
      minLength: "A entrada deve ter pelo menos 2 caracteres",
    },
  },
  textarea: {
    characters: "caracteres",
  },
  time: {
    errors: {
      required: "Este campo é obrigatório",
    },
  },
  form: {
    errors: {
      generic: "Encontramos um erro ao enviar seu formulário. Tente novamente.",
      reportAnIssue: "Por favor, reporte um problema.",
      configuration: "Erro de Configuração",
      noFormQuestionsAvailable: "Nenhuma pergunta de formulário disponível.",
      formComponentLoad:
        "O componente do formulário não pôde ser carregado devido a um campo não suportado.",
      code: "Código",
      type: "Tipo",
      missingRequiredFields:
        "Este formulário não contém os campos obrigatórios (E-mail e/ou Consentimento). Entre em contato com um administrador para corrigir a configuração do formulário.",
    },
  },
};
const ROLES = [
  { value: "Academic", label: "Acadêmico", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Bem-estar Animal - Outros",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Bem-estar Animal - Equipe de Varejo",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Bem-estar Animal - Veterinário",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Bem-estar Animal - Enfermeiro Veterinário",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Bem-estar Animal - Voluntário",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Extensão de Carne Bovina / Confinamento",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Produtor de Carne Bovina",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Criador", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Administrador de Negócios / Recepcionista",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Proprietário / Sócio de Negócio",
    id: "business_owner_partner",
  },
  {
    value: "Consulting Nutritionist",
    label: "Nutricionista Consultor",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Funcionário Corporativo (não DVM)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Produtor de Laticínios",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distribuidor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Representante de Distribuidor, Campo",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Representante de Distribuidor, Interno",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Instituição de Ensino - Estudante do Ensino Médio",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Instituição de Ensino - Estudante TAFE",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Instituição de Ensino - Estudante Universitário",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Tosador", id: "groomer" },
  {
    value: "Medical / Clinic Director",
    label: "Diretor Médico / Clínico",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrição / Vendas de Ração",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Profissional de Nutrição",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutricionista", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Gerente de Escritório / Clínica",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "Varejista OTC", id: "otc_retailer" },
  { value: "Pharmacist", label: "Farmacêutico", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Farmácia - Equipe",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Produtor de Suínos", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Produtor de Aves",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Proprietário de Clínica, Não DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Receptionist / Client Service",
    label: "Recepcionista / Atendimento ao Cliente",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Loja Revendedora - Equipe",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Produtor - Misto/Outro",
    id: "producer_mixed_other",
  },
  {
    value: "Retailer",
    label: "Retalhista",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Produtor de ovinos",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student RAMA", label: "Estudante RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Veterinário/a",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Treinador", id: "trainer" },
  { value: "Veterinarian", label: "Veterinário", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veterinário, Proprietário de Clínica",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Assistente Veterinário",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Enfermeiro Veterinário",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Clínica Veterinária - Outros",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Clínica Veterinária - Veterinário",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Clínica Veterinária - Enfermeiro Veterinário",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veterinário Especialista",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Estudante de Veterinária",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Cirurgião Veterinário",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Técnico Veterinário",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Atacadista", id: "wholesaler" },
];
const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "M.",
    value: "M.",
    id: "m",
  },
  {
    label: "Srta.",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Sr.",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Sra.",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Sra.",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Professor",
    value: "Professor",
    id: "professor",
  },
];
export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
